export default __webpack_public_path__ + "2bd92fe73fa54aa584e72785d0ae2563.svg";